import React from "react";
import SupportLayout from "../support/SupportLayout";
import DriverInterventionsContent from "./components/DriverInterventionsContent";

const AdminDriverInterventions = () => {
  return (
    <SupportLayout userRole="ADMIN">
      <DriverInterventionsContent userRole="ADMIN" />
    </SupportLayout>
  );
};

export default AdminDriverInterventions;
